// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__Lhzb-","error":"form_error__4ZLAs"};